<template>
    <div ref="scaler" class="scaler" :style="style">
        <slot/>
        <dynamic-style :value="deepStyle"/>
    </div>
</template>

<script>

import DynamicStyle from './DynamicStyle'


export default {
    props: [
        'scale'
    ],
    data(){
        return {
            style: '',
            observer: null,
            deepStyle: null
        }
    },
    methods: {
        updateStyle(){
            this.style = `margin-bottom: -${this.$refs.scaler.clientHeight*(1-this.scale)}px;`;
        }
    },
    mounted(){
        this.updateStyle();
        this.observer = new MutationObserver(function(mutations) {
            this.updateStyle();
        }.bind(this));
        this.observer.observe(
            this.$refs.scaler,
            {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            }
        );
        this.deepStyle = `.scaler[${this.$options._scopeId}] > div{
            transform: scale(${this.scale});
            transform-origin: 0 0;
            width: ${100/this.scale}%;
        }`;
    },
    beforeDestroy: function() {
        this.observer.disconnect();
    },
    components: {
        'dynamic-style': DynamicStyle
    }
}

</script>

<style lang="scss" scoped>
    
</style>
